<template>
  <div class="content">
    <b-container>
      <b-row align-h="between">
        <b-col cols="auto">
          <button @click="$router.go(-1)" class="icon-btn">
            <i class="material-icons md-36">arrow_back</i>
          </button>
        </b-col>
        <b-col cols="auto">
          <button @click="restart" class="icon-btn">
            <i class="material-icons md-36">refresh</i>
          </button>
        </b-col>
      </b-row>
    </b-container>
    <b-container v-if="!loaded">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </b-container>
    <b-container v-else>
      <b-row>
        <b-col>
          <p
            v-if="results.length === 0 && bestSellers.length === 0"
            class="title-sm mb-4"
          >Sorry, we could not find anything that matches that criteria</p>
          <p
            v-else-if="results.length === 0"
            class="title-sm mb-4"
          >We could not find anything that fits all the criteria, but check out these bestsellers</p>
          <p v-else class="title-sm mb-4">Here are our recommendations</p>
        </b-col>
      </b-row>
      <b-row v-if="results.length > 0">
        <b-col cols="auto" sm="6" md="4" lg="3" v-for="printer in results" :key="printer.productId">
          <div class="card round-border h-100" @click="show(printer)">
            <div class="card-body d-flex flex-column">
              <h5 class="card-title">{{ printer.name }}</h5>
              <img width="100%" class="mt-auto" :src="printer.image">
              <p class="mt-auto">${{ printer.price }}</p>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row v-else-if="results.length == 0 && bestSellers.length > 0">
        <b-col cols="auto" sm="6" md="4" lg="3" v-for="printer in bestSellers" :key="printer.productId">
          <div class="card round-border h-100" @click="show(printer)">
            <div class="card-body d-flex flex-column">
              <h5 class="card-title">{{ printer.name }}</h5>
              <img width="100%" class="mt-auto" :src="printer.image">
              <p class="mt-auto">${{ printer.price }}</p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
.col-auto {
  padding: 15px;
}
.card {
  color: black;
}
img {
  padding-top: 10px;
  padding-bottom: 10px;
}
.mt-auto {
  margin-bottom: 0px;
}
</style>

<script>
import axios from 'axios';

export default {
  methods: {
    restart() {
      this.$router.push({ name: 'home' });
      localStorage.clear();
    },
    show(printer) {
      this.$ga.event('results', 'click', printer.name);
      this.$router.push({ name: 'printer-details', params: { printer: JSON.stringify(printer) } });
    },
    queryPrinters() {
      let options = JSON.parse(localStorage.getItem('selectedOptions'));

      for (const option in options) {
        if (options[option] === false) {
          delete options[option];
        }
      }

      axios({
        method: 'POST',
        url: `${process.env.VUE_APP_BASE_URL}/printers`,
        data: { options }
      })
        .then(response => {
          // Ensure there are no empty images

          this.results = response.data.printers.filter(result => result.image != '');
          this.bestSellers = response.data.bestSellers.filter(result => result.image != '');
          this.loaded = true;
        })
        .catch(err => console.error(err));
    }
  },
  mounted() {
    this.queryPrinters();
  },
  data() {
    return {
      results: [],
      bestSellers: [],
      loaded: false
    };
  }
};
</script>
